import {
    HDI_TICKET_STATUS_OPENED,
    HDI_TICKET_STATUS_CLOSED,
    HDI_TICKET_STATUS_NEW,
    HDI_TICKET_STATUS_SUSPENDED,
    HDI_TICKET_STATUS_ON_HOLD,
    HDI_TICKET_STATUS_REOPENED,
    HDI_TICKET_STATUS_WAITING_ON_OWNER
} from './form/statusConstants';
import { HDI_ROLE_EDITOR, HDI_ROLE_OWNER } from './roleConstants';

export const ticketRights = {
    VIEW: {
        [HDI_ROLE_OWNER]: {
            canAddAttach: false,
            canAddNotes: false,
            canClose: false,
            canReOpen: false,
            canSave: false,
            canEdit: true,
            isCreate: false,
            canAddInternalNotes: false,
            canShowInternalNotes: false,
        },
        [HDI_ROLE_EDITOR]: {
            canAddAttach: false,
            canAddNotes: false,
            canClose: false,
            canReOpen: false,
            canSave: false,
            canEdit: true,
            isCreate: false,
            canAddInternalNotes: false,
            canShowInternalNotes: true,
        },
    },
    EDIT: {
        [HDI_ROLE_OWNER]: {
            [HDI_TICKET_STATUS_OPENED]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: false,
                canShowInternalNotes: true,
            },
            [HDI_TICKET_STATUS_REOPENED]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: false,
                canShowInternalNotes: true,
            },
            [HDI_TICKET_STATUS_NEW]: {
                canAddAttach: false,
                canAddNotes: false,
                canClose: false,
                canReOpen: false,
                canSave: false,
                canEdit: false,
                isCreate: false,
                canAddInternalNotes: false,
                canShowInternalNotes: true,
            },
            [HDI_TICKET_STATUS_ON_HOLD]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: false,
                canShowInternalNotes: true,
            },
            [HDI_TICKET_STATUS_SUSPENDED]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: false,
                canShowInternalNotes: true,
            },
            [HDI_TICKET_STATUS_CLOSED]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: true,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: false,
                canShowInternalNotes: true,
            },
            [HDI_TICKET_STATUS_WAITING_ON_OWNER]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: false,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: false,
                canShowInternalNotes: true,
            }
        },
        [HDI_ROLE_EDITOR]: {
            [HDI_TICKET_STATUS_OPENED]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: true,
                canShowInternalNotes: true,
                canShowHistory: true,
            },
            [HDI_TICKET_STATUS_REOPENED]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: true,
                canShowInternalNotes: true,
                canShowHistory: true,
            },
            [HDI_TICKET_STATUS_NEW]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: true,
                canShowInternalNotes: true,
                canShowHistory: true,
            },
            [HDI_TICKET_STATUS_ON_HOLD]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: true,
                canShowInternalNotes: true,
                canShowHistory: true,
            },
            [HDI_TICKET_STATUS_SUSPENDED]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: true,
                canShowInternalNotes: true,
                canShowHistory: true,
            },
            [HDI_TICKET_STATUS_CLOSED]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: true,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: true,
                canShowInternalNotes: true,
                canShowHistory: true,
            },
            [HDI_TICKET_STATUS_WAITING_ON_OWNER]: {
                canAddAttach: true,
                canAddNotes: true,
                canClose: true,
                canReOpen: false,
                canSave: true,
                canEdit: true,
                isCreate: false,
                canAddInternalNotes: true,
                canShowInternalNotes: true,
                canShowHistory: true,
            }
        },
    }
};

export const createRights = {
    canAddAttach: true,
    canAddNotes: false,
    canClose: false,
    canReOpen: false,
    canSave: true,
    canEdit: false,
    isCreate: true,
    canAddInternalNotes: false,
    canShowInternalNotes: false,
    canShowHistory: false,
};

export const noRights = {
    canAddAttach: false,
    canAddNotes: false,
    canClose: false,
    canReOpen: false,
    canSave: false,
    canEdit: false,
    isCreate: false,
    canAddInternalNotes: false,
    canShowInternalNotes: false,
    canShowHistory: false,
};

export const editListButtonVisibility = {
    EDITOR: [
        HDI_TICKET_STATUS_OPENED,
        HDI_TICKET_STATUS_REOPENED,
        HDI_TICKET_STATUS_CLOSED,
        HDI_TICKET_STATUS_NEW,
        HDI_TICKET_STATUS_SUSPENDED,
        HDI_TICKET_STATUS_ON_HOLD,
        HDI_TICKET_STATUS_WAITING_ON_OWNER,
    ],
    OWNER: [
        HDI_TICKET_STATUS_OPENED,
        HDI_TICKET_STATUS_REOPENED,
        HDI_TICKET_STATUS_CLOSED,
        HDI_TICKET_STATUS_SUSPENDED,
        HDI_TICKET_STATUS_ON_HOLD,
        HDI_TICKET_STATUS_WAITING_ON_OWNER,
    ]
};
